import { http } from '../config/config-receituario'

export default {    
    salvar: (token, prospect) => {
        return http.post('prospects', prospect, {
            headers: {
                'Authorization': token
            }
        })
    },
}